import { ConvertibleAction } from 'types/ConvertibleAction'
import { ConvertibleEntity } from 'types/ConvertibleEntity'
import { ActionFormWithId as ConvertibleActionFormWithId } from '../../pages/admin/convertibles/edit-convertible/AdminConvertibleEventsFields'

export const getConvertibleLoanAmount = (convertible: ConvertibleEntity) => {
    if (!convertible.convertibleActions || convertible.convertibleActions.length === 0) return null

    return convertible.convertibleActions.reduce(
        (acc: number, action: ConvertibleAction | ConvertibleActionFormWithId) => {
            if (action.actionType === 'new_loan' && action.loanAmount !== null) {
                acc += action.loanAmount
            }
            return acc
        },
        0,
    )
}
